exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width-box {\n  width: 96%;\n  padding-top: 15px; }\n\n.multi-layout-checkbox {\n  padding: 0 15px 0 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 200px; }\n\n.full-width-checkbox {\n  padding: 0 15px 0 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 100%; }\n\n.select-all-label {\n  background-color: #2980b9;\n  color: #ffffff;\n  cursor: pointer;\n  padding: 2px 4px;\n  border-radius: 1px; }\n\n.select-all-label:hover {\n  background-color: #1b6d85;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/user/user-form/user-form.component.scss
// module id = ../../../../../angular/app/views/user/user-form/user-form.component.scss
// module chunks = main